import { Content } from "../../types/content.interface";

export const technicalSkillData: Content[] = [
  {
    enSubtitle: "Language",
    krSubtitle: "Language",
    isDisplay: true,
    details: [
      {
        frontBold: "C/C++, Typescript, Python",
        enText: ", JAVA",
        krText: ", JAVA",
        isDisplay: true,
      },
    ],
  },
  {
    enSubtitle: "Framework",
    krSubtitle: "Framework",
    isDisplay: true,
    details: [
      {
        frontBold: "Nest.js, FastAPI, express",
        enText: ", React, Next.js",
        krText: ", React, Next.js",
        isDisplay: true,
      },
    ],
  },
  {
    enSubtitle: "Database",
    krSubtitle: "Database",
    isDisplay: true,
    details: [
      {
        frontBold: "MySQL, DynamoDB",
        enText: ", Chroma, Elasticsearch",
        krText: ", Chroma, Elasticsearch",
        isDisplay: true,
      },
    ],
  },
  {
    enSubtitle: "CI/CD",
    krSubtitle: "CI/CD",
    isDisplay: false,
    details: [
      {
        frontBold: "Terraform, Github Action",
        enText: ", Jenkins",
        krText: ", Jenkins",
        isDisplay: false,
      },
    ],
  },
  {
    enSubtitle: "Others",
    krSubtitle: "Others",
    isDisplay: true,
    details: [
      {
        frontBold: "AWS, Docker, Terraform",
        enText: ", Github Action, Jenkins, Git, Selenium",
        krText: ", Github Action, Jenkins, Git, Selenium",
        isDisplay: true,
      },
    ],
  },
];
